import { Avatar, Typography, useTheme } from '@mui/material';
import React from 'react';
import { IIdP } from 'types/api';

interface IIdPIconProps {
	idp: IIdP;
	width?: number;
	height?: number;
}

const defaultSize = 32;

const IdPIcon: React.FC<IIdPIconProps> = ({
	idp,
	width = defaultSize,
	height = defaultSize
}) => {
	const {
		palette: { mode }
	} = useTheme();

	const icon = mode === 'dark' ? idp.logos.dark : idp.logos.light;

	if (!icon) {
		return (
			<Avatar
				alt={`${idp.name} icon`}
				sx={{ bgcolor: 'primary.light', color: 'grey.700', width, height }}
			>
				<Typography variant="subtitle1" fontSize={`${width / defaultSize}rem`}>
					{intl.tr('general.idp')}
				</Typography>
			</Avatar>
		);
	}

	return (
		<img src={icon} alt={`${idp.name} icon`} width={width} height={height} />
	);
};

export default IdPIcon;
